<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="loadingItem">
    <h1 class="content-heading-font">System Features</h1>
    <div class="div-loading">Loading system feature...</div>
  </div>
  <div class="main-page-content-block" *ngIf="!currentItem && !loadingItem">
    <div class="float-end d-flex flex-wrap gap-2 mb-3">
      <button class="btn btn-primary" type="button" (click)="openFeatureOrder()" [disabled]="loadingOrder || savingOrder">Reorder features</button>
      <a class="btn btn-secondary" [routerLink]="['/system-settings']">View settings</a>
    </div>
    <h1 class="content-heading-font">System Features</h1>
    <p>Manage the features used by system settings and permissions.</p>
    <p-table #dt dataKey="ID" [value]="list?.Result || []" [paginator]="true" [rows]="25"
             [loading]="loadingList" [showCurrentPageReport]="true"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords} features"
             [rowsPerPageOptions]="[10, 25, 50, 100]" [totalRecords]="list?.FilteredRecords || 0"
             [lazy]="true" (onLazyLoad)="loadTable($event)" sortField="Name" [sortOrder]="1"
             styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th pSortableColumn="ID" class="d-none d-xl-table-cell text-nowrap">
            # <p-sortIcon field="ID"></p-sortIcon>
            <p-columnFilter type="numeric" field="ID" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Name" class="text-nowrap">
            Name <p-sortIcon field="Name"></p-sortIcon>
            <p-columnFilter type="text" field="Name" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Description" class="d-none d-md-table-cell text-nowrap">
            Description <p-sortIcon field="Description"></p-sortIcon>
            <p-columnFilter type="text" field="Description" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Title" class="d-none d-xl-table-cell text-nowrap">
            Title <p-sortIcon field="Title"></p-sortIcon>
            <p-columnFilter type="text" field="Title" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Icon" class="d-none d-xl-table-cell  text-center text-nowrap">
            Icon <p-sortIcon field="Icon"></p-sortIcon>
            <p-columnFilter type="text" field="Icon" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>    
          <th pSortableColumn="SystemSettings" class="d-none d-lg-table-cell text-end  text-nowrap">
            Settings <p-sortIcon field="SystemSettings"></p-sortIcon>

            <p-columnFilter type="numeric" field="SystemSettings" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Permissions" class="d-none d-lg-table-cell text-end  text-nowrap">
            Permissions <p-sortIcon field="Permissions"></p-sortIcon>

            <p-columnFilter type="numeric" field="Permissions" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <a class="btn btn-sm btn-primary" [routerLink]="['/system-settings/features', item.ID]" [attr.aria-label]="'Edit ' + item.Name" title="Edit">
              <i class="pi pi-pen-to-square"></i>
            </a>
          </td>
          <td class="d-none d-xl-table-cell">{{item.ID}}</td>
          <td>{{item.Name}}</td>
          <td class="d-none d-md-table-cell  text-truncate">{{item.Description}}</td>
          <td class="d-none d-xl-table-cell">{{item.Title}}</td>
          <td class="d-none d-xl-table-cell text-center"><i class="fa {{ item.Icon }}" *ngIf="item.Icon!=null"></i></td>
          <td class="d-none d-lg-table-cell text-end"><a [routerLink]="['/system-settings']" [queryParams]="{FeatureID: item.ID}">{{item.SystemSettings}}</a></td>
          <td class="d-none d-lg-table-cell text-end">{{item.Permissions}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        <button class="btn btn-primary me-2" type="button" (click)="loadTable()" title="Refresh" [disabled]="loadingList">
          <i class="pi pi-refresh" [class.pi-spin]="loadingList"></i>
        </button>
        <button class="btn btn-primary" type="button" (click)="clear(dt)" title="Clear filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </ng-template>
      <ng-template pTemplate="emptymessage"><tr><td colspan="10">No features found.</td></tr></ng-template>
    </p-table>
  </div>
  <div class="main-page-content-block" *ngIf="currentItem">
    <button class="btn btn-secondary float-end" type="button" (click)="cancel()" [disabled]="saving">View features</button>
    <h1 class="content-heading-font">Feature #{{currentItem.ID}} - {{currentItem.Name}}</h1>
    <p class="text-muted">The feature ID is fixed to preserve its existing settings, permissions and client switches.</p>
    <form [formGroup]="form" (ngSubmit)="save()">
      <fieldset [disabled]="saving">
        <div class="row">
          <div class="col-12 mb-3">
            <label for="featureName">Name</label>
            <input id="featureName" class="form-control" formControlName="Name" maxlength="50" />
          </div>
          <div class="col-12 mb-3">
            <label for="featureDescription">Description</label>
            <textarea id="featureDescription" class="form-control" formControlName="Description" maxlength="1000" rows="4"></textarea>
          </div>
          <div class="col-12 col-md-6 col-lg-6 mb-3">
            <label for="featureTitle">Title</label>
            <input id="featureTitle" class="form-control" formControlName="Title" maxlength="255" />
          </div>
          <div class="col-12 col-md-6 col-lg-3 mb-3">
            <label for="featureIcon">Icon <a href="https://fontawesome.com/v6/icons" target="icons"><i class="ms-2 pi pi-info-circle" style="font-size: 0.7rem"></i></a></label>
            <div class="input-group mb-2">
              <div class="input-group-prepend">
                <div class="input-group-text">
                  <div style=" height: 24px; width: 20px;">
                    <i class="fa {{ featureIconValue }}" *ngIf="featureIconValue"></i>
                  </div>
                </div>
              </div>
              <input class="form-control" name="featureIcon" formControlName="Icon" autocomplete="off" placeholder="Icon" />
            </div>
          </div>

          <div class="col-12 col-lg-3 mb-3">
            <label for="featureOrder">Order</label>
            <input id="featureOrder" class="form-control" type="number" min="0" max="2147483647" step="1" formControlName="FeatureOrder" />
            <small class="text-muted">Lower numbers display first in System Settings. Use Reorder features to arrange the full list.</small>
            <div class="text-danger" *ngIf="form.controls['FeatureOrder'].touched && form.controls['FeatureOrder'].invalid">Enter a non-negative whole number.</div>
          </div>

          
          <div class="col mb-3">
            <label for="featureInitialValue">Initial value</label>
            <select class="form-control" name="featureInitialValue" formControlName="InitialValue">
              <option value="false">Inactive</option>
              <option value="true">Active</option>
            </select>
            <div class="text-muted">Changing this value does not change existing client switches.</div>
          </div>          

          <div class="col-12 mb-3">
            <h2>Related settings</h2>
            <p>Show or hide dynamic settings for each scope. Use the arrows to arrange each list; display order is shared between scopes. Hidden settings remain available in Management. Archived settings are not listed.</p>
            <label for="settingsVisibilityScope" class="form-label">Settings visibility</label>
            <select id="settingsVisibilityScope" class="form-select mb-3" [ngModel]="settingsScope" [ngModelOptions]="{standalone: true}" (ngModelChange)="changeSettingsScope($event)" [disabled]="saving">
              <option value="enterprise">Enterprise settings</option>
              <option value="company">Company settings</option>
            </select>
            <div class="row g-3">
              <div class="col-12 col-lg-6">
                <h3 class="h5">Visible settings ({{visibleSettings.length}})</h3>
                <ng-container *ngTemplateOutlet="settingsList; context: { $implicit: visibleSettings, visible: true }"></ng-container>
              </div>
              <div class="col-12 col-lg-6">
                <h3 class="h5">Hidden settings ({{hiddenSettings.length}})</h3>
                <ng-container *ngTemplateOutlet="settingsList; context: { $implicit: hiddenSettings, visible: false }"></ng-container>
              </div>
            </div>
          </div>
          <div class="col-12 text-center">
            <button class="btn btn-lg btn-primary" type="submit" [class.button-loading]="saving" [disabled]="saving">Save</button>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</div>

<ng-template #settingsList let-items let-visible="visible">
  <ul class="list-group overflow-auto" style="max-height: 60vh">
    <li *ngFor="let setting of items; let index = index" class="list-group-item">
      
      <div class="float-right gap-2">
        <ng-container *ngTemplateOutlet="orderButtons; context: { items: items, index: index, name: setting.Name }"></ng-container>
        <button class="btn btn-sm btn-secondary ms-2" type="button" (click)="setSettingVisibility(setting, !visible)" [disabled]="saving"
                [attr.aria-label]="(visible ? 'Hide ' : 'Show ') + setting.Name">
          <i [class]="visible ? 'pi pi-eye-slash' : 'pi pi-eye'"></i> {{visible ? 'Hide' : 'Show'}}
        </button>
      </div>
      <div class="d-flex align-items-center gap-2 mb-2">
        <span class="badge bg-secondary text-dark">{{index + 1}}</span>
        <div>{{setting.Name}} <br /> <span class="text-muted">{{setting.Description}}</span></div>
        
      </div>
    </li>
    <li *ngIf="!items.length" class="list-group-item text-muted">No {{visible ? 'visible' : 'hidden'}} settings.</li>
  </ul>
</ng-template>

<ng-template #orderButtons let-items="items" let-index="index" let-name="name">
  <div class="btn-group" role="group" [attr.aria-label]="'Reorder ' + name">
    <button class="btn btn-sm btn-secondary" type="button" (click)="moveItem(items, index, 0)"
            [disabled]="saving || savingOrder || index === 0" title="Move to top" [attr.aria-label]="'Move ' + name + ' to top'">
      <i class="pi pi-angle-double-up"></i>
    </button>
    <button class="btn btn-sm btn-secondary" type="button" (click)="moveItem(items, index, index - 1)"
            [disabled]="saving || savingOrder || index === 0" title="Move up" [attr.aria-label]="'Move ' + name + ' up'">
      <i class="pi pi-arrow-up"></i>
    </button>
    <button class="btn btn-sm btn-secondary" type="button" (click)="moveItem(items, index, index + 1)"
            [disabled]="saving || savingOrder || index === items.length - 1" title="Move down" [attr.aria-label]="'Move ' + name + ' down'">
      <i class="pi pi-arrow-down"></i>
    </button>
    <button class="btn btn-sm btn-secondary" type="button" (click)="moveItem(items, index, items.length - 1)"
            [disabled]="saving || savingOrder || index === items.length - 1" title="Move to bottom" [attr.aria-label]="'Move ' + name + ' to bottom'">
      <i class="pi pi-angle-double-down"></i>
    </button>
  </div>
</ng-template>

<p-dialog header="Reorder features" [modal]="true" [(visible)]="reorderVisible" (onHide)="closeFeatureOrder()"
          [closable]="!savingOrder" [closeOnEscape]="!savingOrder" [style]="{ width: '48rem', 'max-width': '95vw' }">
  <p>Choose the order of the feature groups on System Settings. Changes take effect after saving.</p>
  <p *ngIf="loadingOrder" role="status">Loading features...</p>
  <ul class="list-group" *ngIf="!loadingOrder">
    <li *ngFor="let feature of orderedFeatures; let index = index" class="list-group-item d-flex flex-wrap align-items-center justify-content-between gap-2">
      <span><span class="badge bg-secondary text-dark me-2" title="Number of related settings" [attr.aria-label]="(feature.SystemSettings ?? 0) + ' related settings'">{{feature.SystemSettings ?? 0}}</span>{{feature.Title || feature.Name}}</span>
      <ng-container *ngTemplateOutlet="orderButtons; context: { items: orderedFeatures, index: index, name: feature.Title || feature.Name }"></ng-container>
    </li>
    <li *ngIf="!orderedFeatures.length" class="list-group-item text-muted">No features found.</li>
  </ul>
  <ng-template pTemplate="footer">
    <button class="btn btn-secondary me-2" type="button" (click)="closeFeatureOrder()" [disabled]="savingOrder">Cancel</button>
    <button class="btn btn-primary" type="button" (click)="saveFeatureOrder()" [disabled]="loadingOrder || savingOrder || !orderedFeatures.length" [class.button-loading]="savingOrder">Save order</button>
  </ng-template>
</p-dialog>
